import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { showErrorToast } from '../../utils/toast';

const initialState = {
  secrets: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPrevPage: false,
  },
  loading: false,
  error: null,
  filters: {
    search: '',
    page: 1,
    pageSize: 10,
    sortBy: 'createdAt',
    sortOrder: 'desc',
  },
};

export const fetchSecrets = createAsyncThunk(
  'secrets/fetchSecrets',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { filters } = getState().secrets;
      const queryParams = new URLSearchParams({
        page: filters.page,
        pageSize: filters.pageSize,
        search: filters.search,
        sortBy: filters.sortBy,
        sortOrder: filters.sortOrder,
      });

      const response = await axiosInstance.get(`/config/secrets?${queryParams}`);
      console.log(response.data,"ddddadsd")
      // Here, ensure the data returned matches the structure of your expected payload
      return {
        secrets: response.data.data, // Array of secrets
        pagination: {
          totalItems: response.data.data.totalItems,
          currentPage: response.data.data.currentPage,
          totalPages: response.data.data.totalPages,
          pageSize: response.data.data.pageSize,
        },
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch secrets';
      showErrorToast(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);


export const createSecret = createAsyncThunk(
  'secrets/createSecret',
  async (secretPayload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/secrets', secretPayload);
      return response.data.data.data.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to create secret';
      showErrorToast(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateSecret = createAsyncThunk(
  'secrets/updateSecret',
  async ({ key, value }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/secrets/${key}`, { value });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to update secret';
      showErrorToast(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

const secretsSlice = createSlice({
  name: 'secrets',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSecrets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSecrets.fulfilled, (state, action) => {
        state.loading = false;
        state.secrets = action.payload.secrets;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchSecrets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createSecret.fulfilled, (state, action) => {
        state.secrets.unshift(action.payload);
      })
      .addCase(updateSecret.fulfilled, (state, action) => {
        const index = state.secrets.findIndex(secret => secret.key === action.payload.key);
        if (index !== -1) {
          state.secrets[index] = action.payload;
        }
      });
  },
});

export const { setFilter, resetFilters } = secretsSlice.actions;
export default secretsSlice.reducer;

